import React from 'react';
import _startCase from 'lodash/startCase';
import { makeStyles } from 'design-system';
import { useProjectInstructionContext } from '../projectInstructionContext';

const InstructionHeader = () => {
  const classes = useStyles();
  const { title } = useProjectInstructionContext();
  return (
    <>
      <div className={classes.titleWrapper}>
        <div className={classes.title}>{_startCase(title)}</div>
      </div>
    </>
  );
};

const useStyles = makeStyles(() => ({
  titleWrapper: {
    display: 'flex',
    height: 100,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 24,
    fontWeight: 500,
    color: '#1F2937',
  },
}));

export default InstructionHeader;
